import { z } from 'zod';

const envSchema = z.object({
  VITE_SUPABASE_URL: z.string().min(1).optional().default('your-project.supabase.co'),
  VITE_SUPABASE_ANON_KEY: z.string().min(1).optional().default('your-anon-key'),
  VITE_STRIPE_PUBLIC_KEY: z.string().optional(),
  VITE_GOOGLE_MAPS_API_KEY: z.string().optional(),
  VITE_OPENAI_API_KEY: z.string().optional(),
  API_URL: z.string().optional().default('/api/v1'),
  JWT_SECRET: z.string().optional().default('your-jwt-secret-key'),
  JWT_EXPIRES_IN: z.string().optional().default('7d'),
  STRIPE_SECRET_KEY: z.string().optional(),
  STRIPE_WEBHOOK_SECRET: z.string().optional(),
  MAKE_WEBHOOK_URL: z.string().optional(),
});

function validateEnv() {
  try {
    const parsed = envSchema.parse({
      VITE_SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
      VITE_SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY,
      VITE_STRIPE_PUBLIC_KEY: import.meta.env.VITE_STRIPE_PUBLIC_KEY,
      VITE_GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
      VITE_OPENAI_API_KEY: import.meta.env.VITE_OPENAI_API_KEY,
      API_URL: process.env.API_URL || '/api/v1',
      JWT_SECRET: process.env.JWT_SECRET || 'your-jwt-secret-key',
      JWT_EXPIRES_IN: process.env.JWT_EXPIRES_IN || '7d',
      STRIPE_SECRET_KEY: process.env.STRIPE_SECRET_KEY,
      STRIPE_WEBHOOK_SECRET: process.env.STRIPE_WEBHOOK_SECRET,
      MAKE_WEBHOOK_URL: process.env.MAKE_WEBHOOK_URL,
    });

    return {
      ...parsed,
      VITE_SUPABASE_URL: parsed.VITE_SUPABASE_URL.startsWith('http') 
        ? parsed.VITE_SUPABASE_URL 
        : `https://${parsed.VITE_SUPABASE_URL}`,
    };
  } catch (error) {
    if (import.meta.env.DEV) {
      console.warn('⚠️ Using development environment variables');
      return {
        VITE_SUPABASE_URL: 'https://your-project.supabase.co',
        VITE_SUPABASE_ANON_KEY: 'your-anon-key',
        VITE_STRIPE_PUBLIC_KEY: undefined,
        VITE_GOOGLE_MAPS_API_KEY: 'AIzaSyDLGq0EIoV2HQXJZXYGhQvLJDr1dzvY',
        VITE_OPENAI_API_KEY: undefined,
        API_URL: '/api/v1',
        JWT_SECRET: 'dev-jwt-secret-key',
        JWT_EXPIRES_IN: '7d',
        STRIPE_SECRET_KEY: 'sk_test_stripe_secret_key',
        STRIPE_WEBHOOK_SECRET: 'whsec_stripe_webhook_secret',
        MAKE_WEBHOOK_URL: 'https://hook.make.com/your-webhook',
      };
    }
    
    // Handle error properly by checking its type first
    if (error instanceof z.ZodError) {
      console.error('❌ Invalid environment variables:', error.format());
    } else {
      console.error('❌ Unknown error validating environment variables:', error);
    }
    throw new Error('Invalid environment variables');
  }
}

export const env = validateEnv();